var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_29122",
    "data-name": "Group 29122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.363,
    height: 21.876,
    viewBox: "0 0 31.363 21.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18955",
    "data-name": "Rectangle 18955",
    width: 31.363,
    height: 21.876,
    fill: "#ea555f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29122-2",
    "data-name": "Group 29122",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65312",
    "data-name": "Path 65312",
    d: "M5.2,1.157h0A4.209,4.209,0,0,1,9.356,5.311a4.152,4.152,0,0,1-4.14,4.152H5.188A4.153,4.153,0,0,1,5.2,1.157",
    transform: "translate(-0.042 -0.047)",
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65313",
    "data-name": "Path 65313",
    d: "M27.261,1.157h0a4.209,4.209,0,0,1,4.154,4.155,4.152,4.152,0,0,1-4.14,4.152h-.027a4.153,4.153,0,0,1,.013-8.306",
    transform: "translate(-0.935 -0.047)",
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65314",
    "data-name": "Path 65314",
    d: "M10.953,5.262A5.262,5.262,0,0,1,16.215,0h0a5.331,5.331,0,0,1,5.259,5.262,5.258,5.258,0,0,1-5.249,5.259H16.2a5.259,5.259,0,0,1-5.25-5.259",
    transform: "translate(-0.443 0)",
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65315",
    "data-name": "Path 65315",
    d: "M24.183,17.555V20.42a18.052,18.052,0,0,1-16.234,0V17.56a5.907,5.907,0,0,1,5.9-5.9h4.435a5.907,5.907,0,0,1,5.9,5.9",
    transform: "translate(-0.322 -0.472)",
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65316",
    "data-name": "Path 65316",
    d: "M6.622,17.038a5.9,5.9,0,0,1,2.944-5.1,3.77,3.77,0,0,0-2.918-1.4H3.795A3.8,3.8,0,0,0,0,14.335v1.84A11.569,11.569,0,0,0,6.622,17.3Z",
    transform: "translate(0 -0.427)",
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65317",
    "data-name": "Path 65317",
    d: "M25.661,17.038a5.9,5.9,0,0,0-2.944-5.1,3.77,3.77,0,0,1,2.918-1.4h2.853a3.8,3.8,0,0,1,3.795,3.795v1.84A11.569,11.569,0,0,1,25.661,17.3Z",
    transform: "translate(-0.919 -0.427)",
    fill: "#ea555f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.346b4b2001c29b775c1cb47189cf513c.svg";
export { ForwardRef as ReactComponent };